import { z } from "zod"

const visitSchema = z.object({
  id: z.string(),
  visit_number: z.string().min(1, "Visit number is required"),
  study_week: z.string().optional(),
  study_day: z.string().optional(),
  window_days: z.string().optional(),
})

const periodSchema = z.object({
  name: z.string().min(1, "Period name is required"),
  visits: z.array(visitSchema).min(1, "Each period must have at least one visit"),
})

const assessmentSchema = z.object({
  category: z.string().optional(),
  name: z.string().min(1, "Assessment name is required"),
  scheduled_visits: z.array(z.number()).optional(),
})

const partSchema = z.object({
  name: z.string().min(1, "Part name is required"),
  periods: z.array(periodSchema),
  assessments: z.array(assessmentSchema),
})

export const protocolFormSchema = z.object({
  study_title: z.string().optional(),
  sponsor: z.string().optional(),
  phase: z.string().optional(),
  parts: z.array(partSchema).min(1, "At least one part is required"),
})

export type ProtocolFormData = z.infer<typeof protocolFormSchema>
